import { useState } from 'react';

import { cn } from '@/design-system/lib/cn';

import { DateField } from './DateField';

export type DateRange = { from: string; to: string };

export type DateRangeFieldProps = {
  value: DateRange;
  onChange: (value: DateRange) => void;
  min?: string;
  max?: string;
  fromLabel?: string;
  toLabel?: string;
  disabled?: boolean;
  /** Classe de cada `<label>` — os dois entram na grade de quem usa. */
  labelClassName?: string;
};

/**
 * Intervalo de datas: "De" e "Até" lado a lado, cada um um `DateField`, com o período
 * destacado nos dois calendários. Escolher o começo no calendário abre o do fim, já no
 * mês certo; um começo depois do fim limpa o fim. Devolve os dois rótulos soltos (sem
 * caixa em volta), para caberem na grade do formulário.
 */
export function DateRangeField({
  value,
  onChange,
  min,
  max,
  fromLabel = 'De',
  toLabel = 'Até',
  disabled,
  labelClassName,
}: DateRangeFieldProps) {
  const [toOpen, setToOpen] = useState(false);
  const range = { from: value.from || null, to: value.to || null };
  const label = cn('flex flex-col gap-1.5', labelClassName);

  return (
    <>
      <label className={label}>
        <span className="text-small font-semibold">{fromLabel}</span>
        <DateField
          value={value.from}
          min={min}
          max={max}
          range={range}
          disabled={disabled}
          onChange={(from) => onChange({ from, to: value.to && from && value.to < from ? '' : value.to })}
          onPick={() => {
            if (!value.to) setToOpen(true);
          }}
        />
      </label>
      <label className={label}>
        <span className="text-small font-semibold">{toLabel}</span>
        <DateField
          value={value.to}
          min={value.from || min}
          max={max}
          range={range}
          defaultMonth={value.from || undefined}
          disabled={disabled}
          open={toOpen}
          onOpenChange={setToOpen}
          onChange={(to) => onChange({ ...value, to })}
        />
      </label>
    </>
  );
}
